export default __webpack_public_path__ + "static/media/donati-banner-mobile.8a63c098.jpg";